module.exports = __webpack_public_path__ + "img/矩形 2829.3464b6cc.png";